export class StringUtils {
  /**
   * @deprecated use template strings instead
   */
  public static format(format: string, params: any[]): string {
    for (let i = 0; i < params.length; i++) {
      const key = i.toString();
      format = format.split(`{${key}}`).join(params[i].toString());
    }
    return format;
  }
}
